export const auth = {
  login: "/auth/login",

  resetPassword: "/auth/forgot-password",
  resetPassSuccess: "/auth/reset-password/success",
  setPassword: "/auth/confirm-reset-password",
  setPassSuccess: "/auth/set-password/success"
};

export const candidate = {
  signUp: "/auth/signup",
  onboarding: "/profile/setup",
  candidateDashboard: "/dashboard",
  candidateDashboardCall: "/dashboard/call/:id",
  editProfile: "/user/profile/",
  chooseTime: "/insiders/:id/choose-time",
  inviteFriend: "/user/invite",
  inviteSuccess: "/user/invite/success",
  call: "/call/:id",
  cancelSuccess: "/cancel/success",
  cancelCall: "/insiders/:id/cancel",
  insiderProfile: "/insiders/:id",
  scheduleCall: "/insiders/:id/book",
  main: "/",
  consultation: "/consultation",
  profiles: "/profiles",
  pay: "/insiders/:id/payment",
  reschedule: "/insiders/:id/reschedule",
  rescheduleSuccess: "/reschedule/success",
  paymentSuccess: "/payment/success",
  onInsiderFeedback: "/feedback/insider",
  candidateFeedbackSuccess: "/feedback/candidate/success"
};

export const insider = {
  insiderSignUp: "/auth/insider/signup",
  insiderSignUpSuccess: "/auth/insider/signup/success",
  insiderMain: "/insider/dashboard",
  insiderCallDetails: "/insider/call/:id",
  insiderDashboardProfile: "/insider/profile",
  insiderPaymentCallback: "/insider/payment-callback",
  onCandidateFeedback: "/feedback/candidate",
  insiderFeedbackSuccess: "/feedback/insider/success",
  insiderReferral: "/insider/invite",
  insiderReferralSuccess: "/insider/invite/success",
  invalidToken: "/auth/insider/invalid-token",
  onboarding: "/insider/profile/setup",
  reviews: "/insider/reviews"
};



// WEBPACK FOOTER //
// ./src/routes/paths.js